import { IProductModel } from "@nf/common";
import { useTranslation } from "next-i18next";

import LandingPageOffer from "../LandingPageOffer";

import styles from "./LandingPageOffers.module.scss";

interface LandingPageOffersProps {
  offers: IProductModel[];
}

const LandingPageOffers = ({ offers }: LandingPageOffersProps) => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.container}>
      <div className={styles.offers}>
        {offers?.map((offer) => (
          <LandingPageOffer key={offer.Id} offer={offer} />
        ))}
      </div>

      <span className={styles.text}>
        {t("web_landing_page_price_information")}
      </span>
    </div>
  );
};

export default LandingPageOffers;
